import api from "@/service/Api/Api";
import { apiResponse } from "@/service/Api/Api";

export interface deleteUseStartingUrlRequest {}

export interface deleteUseStartingUrlResponse {}

export interface postUseStartingUrlRequest {}

export interface postUseStartingUrlResponse {
  use_starting_url: string;
  is_active: boolean;
}

export interface getUseStartingUrlRequest {}

export interface getUseStartingUrlResponse {
  use_starting_url: string;
  is_active: boolean;
}

export default {
  deleteUseStartingUrl(
    data: deleteUseStartingUrlRequest,
    volumeLicenseId: string
  ): Promise<deleteUseStartingUrlResponse & apiResponse> {
    return api<deleteUseStartingUrlRequest, deleteUseStartingUrlResponse>({
      endpoint:
        "volume-licenses/" + volumeLicenseId + "/web-api/use-starting-url",
      method: "DELETE",
      queryParams: data,
    });
  },
  postUseStartingUrl(
    data: postUseStartingUrlRequest,
    volumeLicenseId: string
  ): Promise<getUseStartingUrlResponse & apiResponse> {
    return api<postUseStartingUrlRequest, postUseStartingUrlResponse>({
      endpoint:
        "volume-licenses/" + volumeLicenseId + "/web-api/use-starting-url",
      method: "POST",
      queryParams: data,
    });
  },
  getUseStartingUrl(
    data: getUseStartingUrlRequest,
    volumeLicenseId: string
  ): Promise<getUseStartingUrlResponse & apiResponse> {
    return api<getUseStartingUrlRequest, getUseStartingUrlResponse>({
      endpoint:
        "volume-licenses/" + volumeLicenseId + "/web-api/use-starting-url",
      method: "GET",
      queryParams: data,
    });
  },
};
